import { SERVICES, SERVICE_LINKS } from "../lib/constants";
import { ServiceCard } from "./ServiceCard";

export function Services() {
  return (
    <section id="servicos" className="section services-section" data-testid="services-section">
      <div className="section-heading" data-testid="services-heading">
        <span className="section-eyebrow" data-testid="services-eyebrow">Serviços principais</span>
        <h2 data-testid="services-title">Guincho, reboque e socorro mecânico com foco em emergência real</h2>
        <p data-testid="services-description">Da pane seca ao transporte de carros de luxo, a Auto Socorro Pedrinho atende Arujá, Dutra e região com comunicação rápida pelo WhatsApp.</p>
      </div>
      <div className="service-link-row" data-testid="service-seo-links">
        {SERVICE_LINKS.map(([name, href], index) => <a key={name} href={href} data-testid={`service-seo-link-${index}`}>{name}</a>)}
      </div>
      <div className="services-grid" data-testid="services-grid">
        {SERVICES.map((service, index) => <ServiceCard key={service} name={service} index={index} />)}
      </div>
      <p className="section-note" data-testid="services-extra-note">Consulte para demais serviços não listados.</p>
    </section>
  );
}